import { isString } from "../types/isString";

export type URLParamValue = string | number | boolean | null | undefined;

export const addParamsToURL = (
  url: string,
  params: Record<string, URLParamValue> | undefined | null,
) => {
  if (!isString(url)) {
    return url;
  }

  // Handle undefined params
  if (!params) {
    return url;
  }

  // Check if URL is absolute (has protocol)
  const isAbsoluteURL = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(url);

  if (isAbsoluteURL) {
    // Handle absolute URLs with URL constructor
    const urlObj = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
      // Convert numbers and booleans to strings, ignore null/undefined
      if (value !== null && value !== undefined) {
        urlObj.searchParams.set(key, String(value));
      }
    });
    return urlObj.toString();
  } else {
    // Handle relative URLs manually
    // First extract hash fragment if present
    const [pathAndQuery, hash] = url.split("#");
    const [basePath, existingQuery] = pathAndQuery.split("?");

    const searchParams = new URLSearchParams(existingQuery || "");

    Object.entries(params).forEach(([key, value]) => {
      // Convert numbers and booleans to strings, ignore null/undefined
      if (value !== null && value !== undefined) {
        searchParams.set(key, String(value));
      }
    });

    const queryString = searchParams.toString();
    let result = queryString ? `${basePath}?${queryString}` : basePath;

    // Add hash fragment back if it existed
    if (hash !== undefined) {
      result += `#${hash}`;
    }

    return result;
  }
};
